export type HighlightFilter = {
  category?: "all" | "local" | "international";
  competition?: string;
  team?: string;
  query?: string;
};

export function filterHighlights<T extends { title: string; competition: string; category: string }>(items: T[], filters: HighlightFilter): T[] {
  const query = (filters.query || "").trim().toLocaleLowerCase("ar");
  return items.filter((item) => {
    const haystack = `${item.title} ${item.competition}`.toLocaleLowerCase("ar");
    return (!filters.category || filters.category === "all" || item.category === filters.category)
      && (!filters.competition || filters.competition === "all" || item.competition === filters.competition)
      && (!filters.team || filters.team === "all" || item.title.includes(filters.team))
      && (!query || haystack.includes(query));
  });
}
